import { Component, Input, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import {
  Customer,
  CustomerService,
  gungAddRemoveSpinner,
  GungModalService,
  SelectedCustomerService
} from 'gung-standard';
import { first } from 'rxjs';
import { ColmecClaimConfigListService } from '../../../services/colmec-claim-config-list.service';
import { ColmecModalService } from '../../../services/colmec-modal.service';
import { ColmecClaimCreateModalComponent } from '../colmec-claim-create-modal/colmec-claim-create-modal.component';

@Component({
    selector: 'colmec-claim-list',
    template: `
    <div *ngIf="!customerId" class="row">
      <div class="col text-center"><h2 translate>CLAIMS</h2></div>
    </div>
    <div *ngIf="!customerId" class="row">
      <div class="col">
        <button type="button" class="btn btn-primary float-right" (click)="createClaim($event)" translate>
          CREATE_CLAIM
        </button>
      </div>
    </div>
    <lib-filter-list #list [configService]="listConfigService"></lib-filter-list>
  `,
    styles: [],
    standalone: false
})
export class ColmecClaimListComponent implements OnInit {
  @Input()
  customerId?: string;

  currentCustomer: Customer;

  constructor(
    public listConfigService: ColmecClaimConfigListService,
    protected ngbModal: NgbModal,
    protected gungModalService: ColmecModalService,
    protected selectedCustomerService: SelectedCustomerService,
    protected customerService: CustomerService,
    protected translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.listConfigService.customerId = this.customerId;
    if (this.customerId) {
      this.customerService
        .getCustomer(this.customerId)
        .pipe(first())
        .subscribe(customer => (this.currentCustomer = customer));
    } else {
      this.selectedCustomerService
        .getSelectedCustomer()
        .pipe(first())
        .subscribe(customer => (this.currentCustomer = customer));
    }
  }

  createClaim(event) {
    gungAddRemoveSpinner(event.target);
    this.gungModalService
      .openClaimModal(this.currentCustomer)
      .then(
        answer => {
          console.log('answer', answer);
          if (answer) {
            const rmanr =
              answer['#result-set-1'] && answer['#result-set-1'].length > 0 && answer['#result-set-1'][0][''];
            this.gungModalService
              .openConfirmYesNoModal(
                null,
                this.translateService.instant('CLAIM_CREATED_SUCCESS', { id: rmanr || '' }),
                null,
                'OK',
                null
              )
              .then(_ => {});
            gungAddRemoveSpinner(event.target);
          } else {
            gungAddRemoveSpinner(event.target);
            // this.gungModalService.openConfirmYesNoModal(undefined, 'ERROR', { size: 'sm' }, 'OK', null).then(_ => { });
          }
        },
        error => {
          gungAddRemoveSpinner(event.target);
          // this.gungModalService.openConfirmYesNoModal(undefined, 'ERROR', { size: 'sm' }, 'OK', null).then(_ => { });
        }
      )
      .catch(res => gungAddRemoveSpinner(event.target));
  }
}
